import React, { useEffect, useRef } from 'react';

import { focusRef } from '../shared/EventHelpers';

const EditText = ({ value, setValue, onKeyDown, isInvalid, autoFocus }) => {

    const inputRef = useRef();

    const onChange = (e) => {
        setValue(e.target.value);
    }

    useEffect(() => {
        autoFocus && focusRef(inputRef);
        if (value === undefined || value === null) {
            setValue('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='crm-editable-field-wrapper'>
            <input
                ref={inputRef}
                className={`text-input ${isInvalid ? 'invalid' : ''}`}
                value={value ?? ''}
                onKeyDown={onKeyDown}
                onChange={(e) => onChange(e)}
            />
        </div>
    );
};

export default EditText;
